import { useReferenceState } from "lib/@hooks/use-reference"
import { Box, IconButton, Stack, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { blockDndKey } from "lib/@components/block-dnd-key"
import Iconify from "minimals-template/components/Iconify"

export function SortOn({ field, children }) {
    const { sorter = "task-sort", setSkip } = useBoundContext()

    const [sort, setSort] = useReferenceState(sorter, [], "task-sort")
    const sortList = Array.isArray(sort) ? sort : []
    const find = sortList.find((s) => s.replaceAll("-", "") === field)
    const state = find ? (find.startsWith("-") ? "desc" : "asc") : undefined
    return (
        <Stack direction="row" sx={{ width: "auto", flex: "0 1 auto", minWidth: 0 }} spacing={1} alignItems="center">
            <Box flex={1}>{children}</Box>
            <Box lineHeight={0}>
                <Tooltip title={getSortLabel()}>
                    <IconButton
                        size="small"
                        sx={{
                            fontSize: 16,
                            color: state ? "primary.main" : undefined,
                            opacity: state ? 1 : 0.2,
                            "&:hover": { opacity: 1, backgroundColor: "transparent" },
                        }}
                        onClick={change}
                        onKeyDown={blockDndKey}
                        aria-label={getSortLabel()}
                        data-cy="sort-on-button"
                    >
                        {state === "desc" && <Iconify icon="mdi:arrow-upward" data-cy="sort-on-desc" />}
                        {state === "asc" && <Iconify icon="mdi:arrow-downward" data-cy="sort-on-asc" />}
                        {state === undefined && <Iconify icon="mdi:arrow-up-down" data-cy="sort-on-default" />}
                    </IconButton>
                </Tooltip>
            </Box>
        </Stack>
    )

    function getSortLabel() {
        if (state === "asc") return `Sort By Descending`
        if (state === "desc") return `Clear Sort`
        return `Sort By Ascending`
    }

    function change({ shiftKey }) {
        let newMode

        if (!shiftKey) {
            if (state === "asc") newMode = "-" + field
            if (state === "desc") newMode = undefined
            if (!state) newMode = field
        } else {
            if (state === "asc") newMode = undefined
            if (state === "desc") newMode = field
            if (!state) newMode = "-" + field
        }
        setSort([newMode].filter(Boolean))
        setSkip?.(0)
    }
}
